import { TenantEntity } from '../TenantEntity'

export class WarehouseInDetail extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'WarehouseInDetail'
  }

  get packing() {
    return this._data.packing
  }
  set packing(packing) {
    this._data.packing = packing
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage
  }
  get dimension() {
    return this._data.dimension
  }
  set dimension(dimension) {
    this._data.dimension = dimension
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get warehouseInDate() {
    return this._data.warehouseInDate
  }
  set warehouseInDate(warehouseInDate) {
    this._data.warehouseInDate = warehouseInDate
  }
  get warehouseInUuid() {
    return this._data.warehouseInUuid
  }
  set warehouseInUuid(warehouseInUuid) {
    this._data.warehouseInUuid = warehouseInUuid
  }
  get poPackageUuid() {
    return this._data.poPackageUuid
  }
  set poPackageUuid(poPackageUuid) {
    this._data.poPackageUuid = poPackageUuid
  }
  get warehouseOutDate() {
    return this._data.warehouseOutDate
  }
  set warehouseOutDate(warehouseOutDate) {
    this._data.warehouseOutDate = warehouseOutDate
  }
  get singleWeight() {
    return this._data.singleWeight
  }
  set singleWeight(singleWeight) {
    this._data.singleWeight = singleWeight
  }

  get weighbridgeWeightImperial() {
    return this._data.weighbridgeWeightImperial
  }
  set weighbridgeWeightImperial(weighbridgeWeightImperial) {
    this._data.weighbridgeWeightImperial = weighbridgeWeightImperial || 0
  }
  get tareWeightImperial() {
    return this._data.tareWeightImperial
  }
  set tareWeightImperial(tareWeightImperial) {
    this._data.tareWeightImperial = tareWeightImperial || 0
  }
  get grossWeightImperial() {
    return this._data.grossWeightImperial
  }
  set grossWeightImperial(grossWeightImperial) {
    this._data.grossWeightImperial = grossWeightImperial || 0
  }
  get weightImperial() {
    return this._data.weightImperial
  }
  set weightImperial(weightImperial) {
    this._data.weightImperial = weightImperial || 0
  }
  get cubAgeImperial() {
    return this._data.cubAgeImperial
  }
  set cubAgeImperial(cubAgeImperial) {
    this._data.cubAgeImperial = cubAgeImperial || 0
  }
  get dimensionImperial() {
    return this._data.dimensionImperial
  }
  set dimensionImperial(dimensionImperial) {
    this._data.dimensionImperial = dimensionImperial
  }
  get singleWeightImperial() {
    return this._data.singleWeightImperial
  }
  set singleWeightImperial(singleWeightImperial) {
    this._data.singleWeightImperial = singleWeightImperial || 0
  }
}
